export const removeBotFromDOM = () => {
  const botFrame = document.getElementById('askiot-bot-ui');
  const botButton = document.getElementById('askiot-chat-icon');

  if (botFrame) {
    botFrame.remove();
  }

  if (botButton) {
    botButton.remove();
  }
};

export const hasChildWithId = (childNodes: NodeList, id: string) => {
  return Array.from(childNodes).some((node: any) => {
    return node.nodeType === Node.ELEMENT_NODE && node.id === id;
  });
};
